var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.594,
    height: 12.929,
    viewBox: "0 0 13.594 12.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M7.385,11.078l-4.2,2.351.938-4.722L.588,5.438l4.781-.567L7.385.5,9.4,4.872l4.781.567L10.648,8.707l.938,4.722Z",
    transform: "translate(-0.588 -0.5)",
    fill: "#ff3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStar);
export default __webpack_public_path__ + "static/media/red-star.36251b2eb0a8166c4be37fbd20ff4a2a.svg";
export { ForwardRef as ReactComponent };